import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

@Component({
  selector: 'el-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnChanges {
  @Input() name = 'Learn More';

  // outlined button or filled button
  @Input() isFilled = true;

  // this prop used to scale up the button with hover
  @Input() isFocusEnabled = true;

  // this attribute uses to swap the name and icon tag
  @Input() isReverseButtonEnabled = false;

  // this attribute uses to hide the icon tag
  @Input() isArrowHide = false;

  // this attribute uses to disable the button
  @Input() isButtonDisabled = false;

  /**
   * You can define a CSS class and pass the name of that class to this
   * @param {string} innerClass - CSS class name to further style the button component
   */
  @Input() innerClass = '';

  @Output() onClick: EventEmitter<boolean> = new EventEmitter();

  ngClass = {};

  onHandleClick() {
    this.onClick.emit(true);
  }

  ngOnChanges() {
    const newClasses = ['ec-btn'];
    if (this.isFilled && this.isFocusEnabled) {
      newClasses.push('ec-btn__filled');
    }
    if (!this.isFilled && this.isFocusEnabled) {
      newClasses.push('ec-btn__outlined');
    }
    if (this.isFilled && !this.isFocusEnabled) {
      newClasses.push('ec-btn__filled--not-focus');
    }
    if (!this.isFilled && !this.isFocusEnabled) {
      newClasses.push('ec-btn__outlined--not-focus');
    }
    if (this.innerClass) {
      newClasses.push(this.innerClass);
    }
    this.ngClass = newClasses;
  }
}
